import { gql } from "@apollo/client";

export const GetCurrencies = gql`
  query getCurrencies {
    currencyV1 {
      name
      symbol
      currency
    }
  }
`;

export const GetEventWallets = gql`
  query getWallets($event_id: UUID!) {
    getWallets(event_id: $event_id) {
      id
      balance
      currency
      frozen
      event_id
      gift_volume
      status
      pin_is_set
      created_at
      updated_at
    }
  }
`;

export const GetWalletTransactionHistory = gql`
  query getWalletTransactionHistory($walletId: String!) {
    getWalletTransactionHistoryV1(walletId: $walletId) {
      id
      description
      event_uuid
      user {
        id
        first_name
        last_name
        phone_number
        guest
      }
      wallet_id
      currency
      amount
      item_id
      type
      stage
    }
  }
`;

export const GetForeignWalletDetails = gql`
  query getForeignAccountDetails($eventId: Int!) {
    getForeignAccountDetails(event_id: $eventId) {
      id
      event_id
      walletId
      account_number
      bank_name
      currency
      beneficiary_name
      swift_code
      country
      city
      bank_address
      post_code
      sort_code
    }
  }
`;
